import produce from 'immer';
import * as savingActionTypes from '../../constants/actionTypes/saving';

const saving = (state = false, action) => produce(state, () => {
    switch (action.type) {
        case savingActionTypes.UPDATE_SAVING_STATUS:
            return action.payload;
        default:
            return state;
    }
});

export default saving;
